// @flow
import React, { Component } from 'react'
import _ from 'lodash'
import styled, { type StyledComponent } from 'styled-components'
import type { ImportEntityError } from './types'
import { Table, HeaderCell, HeaderRow, BodyRow, Cell } from './MainTable'
import Button from './controls/PrimaryButton'

const ImportButtons: StyledComponent<Object, any, any> = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-left: -10px;
`
const ImportButton: StyledComponent<Object, any, any> = styled(Button)`
  margin-left: 10px;
`
const BoldSpan: StyledComponent<Object, any, any> = styled.span`
  font-weight: bold;
`

type Props = {|
  isLoading: boolean,
  errors: Array<ImportEntityError>,
  onInit: () => void,
  onImport: (provider: string) => void
|}

const t = {
  provider: 'Провайдер',
  error_type: 'Тип ошибки',
  error_description: 'Описание ошибки',
  import: 'Импорт РК и объявлений',
  providers: {
    vk: 'ВКонтакте',
    target_mail: 'myTarget',
    facebook: 'Facebook'
  },
  error_types: {
    no_entities: 'Нет сущностей для импорта',
    request: 'Ошибка запроса',
    audience_validation: 'Ошибка валидаций при создании аудиторий',
    advertisement_validation: 'Ошибка валидаций при создании объявлений',
    incomplete_import: 'Некоторые объекты не были импортированы'
  }
}

const PROVIDERS = ['vk', 'target_mail', 'facebook']

export default class ImportEntityPage extends Component<Props> {
  constructor(props: Props) {
    super(props)
    props.onInit()
  }

  render() {
    return (
      <div>
        <ImportButtons>
          {_.map(PROVIDERS, (provider) => {
            return (
              <ImportButton
                small
                key={provider}
                height={32}
                onClick={() => this.props.onImport(provider)}
                disabled={this.props.isLoading}
              >
                {`${t.import} ${t.providers[provider]}`}
              </ImportButton>
            )
          })}
        </ImportButtons>
        <Table>
          <thead>
            <HeaderRow>
              <HeaderCell alignLeft>{t.provider}</HeaderCell>
              <HeaderCell alignLeft>{t.error_type}</HeaderCell>
              <HeaderCell alignLeft>{t.error_description}</HeaderCell>
            </HeaderRow>
          </thead>
          <tbody>
            {_.map(this.props.errors, (error, index: number) => {
              return (
                <BodyRow key={index}>
                  <Cell alignLeft>{t.providers[error.provider]}</Cell>
                  <Cell alignLeft>{t.error_types[error.error_type]}</Cell>
                  <Cell alignLeft>{this.renderErrorDescription(error)}</Cell>
                </BodyRow>
              )
            })}
          </tbody>
        </Table>
      </div>
    )
  }

  renderErrorDescription(error: ImportEntityError) {
    if (_.isEmpty(error.error_description)) return
    if (typeof error.error_description === 'string') return error.error_description
    if (error.error_type === 'request') return error.error_description
    if (error.error_type === 'incomplete_import') {
      return _.map(error.error_description, (line, index) => {
        return <div key={index}>{line}</div>
      })
    }

    return _.map(error.error_description, (values, key) => {
      return (
        <div key={key}>
          <BoldSpan>{key}: </BoldSpan>
          {_.map(values, (value, index: number) => {
            return <div key={index}>{value}</div>
          })}
        </div>
      )
    })
  }
}
